/**
 * Created by razial on 03.11.2021
 */

const ExpeditionPassHeader = cc.Node.extend({
    ctor: function (options) {
        this.options = options;
        this.passLogic = options.passLogic;

        const styles = cleverapps.styles.ExpeditionPassHeader;

        this._super();
        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(options.width, styles.height);

        const bg = new cleverapps.Spine(bundles[`expeditionpass_${cleverapps.skins.getSlot("skinName")}`].jsons.top_bg);
        bg.setAnimation(0, "animation", true);
        bg.setAlignment(options.width / 2, this.height / 2);
        this.addChild(bg);

        const title = cleverapps.UI.generateOnlyText(Messages.get("ExpeditionPassWindow.header"), cleverapps.styles.FONTS.EXPEDITIONS_PASS_TITLE_TEXT);
        title.setDimensions(styles.titleWidth, 0);
        title.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        title.setAlignment(styles.title);
        this.addChild(title);

        const amount = this.amount = new PassProgressAmount(options);
        amount.setAlignment(styles.amount);
        this.addChild(amount);

        this.createPack(cleverapps.offerManager.findOffer({ mission: this.passLogic.mission.type }));
    },

    createPack: function (offer) {
        if (offer) {
            const pack = new PassHeaderPack(offer, this.options);
            this.addChild(pack);
            pack.setAlignment(cleverapps.styles.ExpeditionPassHeader.pack);
        }
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    EXPEDITIONS_PASS_TITLE_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

cleverapps.styles.ExpeditionPassHeader = {
    x: { align: "center" },
    y: { align: "top", dy: -20 },
    height: 222,
    titleWidth: 900,

    title: {
        x: { align: "center" },
        y: { align: "center", dy: 10 }
    },

    amount: {
        x: { align: "center" },
        y: { align: "center", dy: -85 }
    },

    pack: {
        x: { align: "right", dx: -30 },
        y: { align: "center", dy: 0 }
    }
};
